import { render } from "./AccordionWithList.vue?vue&type=template&id=a2a42ab4"
import script from "./AccordionWithList.vue?vue&type=script&lang=js"
export * from "./AccordionWithList.vue?vue&type=script&lang=js"

import "./AccordionWithList.vue?vue&type=style&index=0&id=a2a42ab4&lang=css"

import exportComponent from "/Users/appitry/Appitry/dscvry-browser/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__